exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.daily-history-page[data-v-32f5fb32] {\n  width: 100%;\n}\n.header-bar[data-v-32f5fb32] {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin: 1rem 0;\n  flex-wrap: wrap;\n}\n", ""]);

// exports
